import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { TrashbinItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Destination } from '../Destination';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Restore } from '../Restore';
import { Trashbin } from '../RowFor/Trashbin';
import { Size } from '../Size';

const TrashbinItem = (props: TrashbinItemProps) => {
    const { deletedFrom, binName, onCheckboxClick, isSelected, isFolder, thumbUrl, kind, ext, name, deletedAt, size, onRestore } = props;
    const windowWidth = useWindowWidth();
    const path = deletedFrom === '/' ? binName : deletedFrom.slice(0, deletedFrom.length - 1);

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Trashbin {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic isFolder={isFolder} thumbUrl={thumbUrl} kind={kind} isVirus={false} ext={ext || ''} />
                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} />
                            <Destination name={path} />
                            <Date date={deletedAt} />
                            <Size size={size} />
                            <Restore onClick={onRestore} />
                        </>
                    ) : (
                        <>
                            {windowWidth <= BREAKPOINT_SM ? (
                                <>
                                    <div className={styles.responsiveNameWrapper}>
                                        <ItemName name={name} ext={ext || ''} />
                                        <Destination name={path} noOverflow />

                                        <span className={styles.responsiveDateWrapper}>
                                            <Size size={size} />
                                            {!!deletedAt && <>&nbsp;•&nbsp;</>}
                                            <Date date={deletedAt} />
                                        </span>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <ItemName name={name} ext={ext || ''} />
                                    <Destination name={path} />
                                    <Date date={deletedAt} />
                                    <Size size={size} />
                                </>
                            )}

                            <div className={styles.actionsWrapper}>
                                <Restore onClick={onRestore} />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default TrashbinItem;
